module.exports = __webpack_public_path__ + "static/media/feather-search.39a23460.svg";